import { isPresentOrDefault } from 'utils/helperMethods';

import {
    CHARGEBACK_STATUS_ENUM,
    CHARGEBACK_MERCHANT_STATUS_ENUM,
} from '../../../utils/constants/commonValues';
import moment from 'moment';

function ChargebackDetailFormat(data) {
    this.chargebackDetails = this.createChargebackDetails(data);
}

ChargebackDetailFormat.prototype = Object.assign(
    ChargebackDetailFormat.prototype,
    {
        createChargebackDetails(data) {
            return {
                transactionData: this.createTransactionData(
                    data.transactionData, data
                ),
                disputeDetails:data?.disputeDetail,
                chargebackData:
                    data.chargebackData && data.chargebackData.length
                        ? data.chargebackData.map(item =>
                            this.createChargeBackDetailData(item))
                        : [],
                chargebackMetaData: {
                    parentChargebackId: data.parentChargebackId,
                    currentChargebackId: data.currentChargebackId,
                    currentChargebackStatus: data.currentChargebackStatus,
                    currentChargebackLevel: data.currentChargebackLevel,
                    latestDueDate: data.latestDueDate
                },
            };
        },
        createDisputeDetails(data) {
            return {
                transactionData: this.createTransactionData(
                    data.transactionData
                ),
                disputeData:
                    data.disputeData && data.disputeData.length
                        ? data.disputeData.map(item =>
                            this.createDisputeDetailData(item))
                        : [],
                disputeMetaData: {
                    parentDisputeId: data.parentDisputeId,
                    currentDisputeId: data.currentDisputeId,
                    currentDisputeStatus: data.currentDisputeStatus,
                    currentDisputeLevel: data.currentDisputeLevel,
                    latestDueDate: data.latestDueDate
                },
            };
        },

        createChargeBackDetailData(details) {
            const {
                customerAgentData,
                merchantData,
                chargebackId,
                cbStatus,
            } = details;
            return {
                customerAgentData: this.createCustomerAgentData(
                    customerAgentData,
                    details
                ),
                merchantData: this.createMerchantData(merchantData),
                levelChargebackId: chargebackId,
                currentChargebackStatus: cbStatus,
            };
        },
        createMerchantData(merchantData) {
            const {
                mrRemarks,
                refundedAmount,
                status,
                date,
                mrDocuments,
            } = merchantData;
            return {
                date: isPresentOrDefault(date, '-'),
                status: isPresentOrDefault(
                    CHARGEBACK_MERCHANT_STATUS_ENUM[status],
                    '-'
                ),
                amount: isPresentOrDefault(refundedAmount, '-'),
                merchantRemarks: isPresentOrDefault(mrRemarks, '-'),
                docs:
                    (mrDocuments &&
                        mrDocuments.length > 0 &&
                        mrDocuments.map(item => {
                            return { name: item.fileName, url: item.requestId };
                        })) ||
                    [],
            };
        },
        createCustomerAgentData(createCustomerAgentData, details) {
            const {
                reportedDate,
                rrnNumber,
                dueDate,
                reasonCode,
                reasonCodeMsg,
                cbRemarks,
                docs,
                cbCreatedDate,
            } = createCustomerAgentData;

            const { cbStatus, cbLevel } = details;

            return {
                reportedDate: isPresentOrDefault(reportedDate, '-'),
                cbCreatedDate: isPresentOrDefault(cbCreatedDate, '-'),
                rrnNumber: isPresentOrDefault(rrnNumber, '-'),
                dueDate: isPresentOrDefault(dueDate, '-'),
                daysRemaining: moment(dueDate, 'YYYY-MM-DD HH:mm:ss').diff(
                    moment(cbCreatedDate, 'YYYY-MM-DD HH:mm:ss'),
                    'days'
                ),
                reasonCode: isPresentOrDefault(reasonCode, '-'),
                chagebackLevel: isPresentOrDefault(cbLevel, '-'),
                reasonCodeMessage: isPresentOrDefault(reasonCodeMsg, '-'),
                chargebackMessage: isPresentOrDefault(cbRemarks, '-'),
                chargebackStatusValue: isPresentOrDefault(cbStatus, '-'),
                chargebackLevel: isPresentOrDefault(cbLevel, '-'),
                chargebackStatus: isPresentOrDefault(
                    CHARGEBACK_STATUS_ENUM[cbStatus]?.label,
                    '-'
                ),
                docs:
                    (docs &&
                        docs.length > 0 &&
                        docs.map(item => {
                            return { name: item.fileName, url: item.requestId };
                        })) ||
                    [],
            };
        },
        createTransactionData(transactionData, data) {
            const {
                transactionId,
                dateTime,
                amount,
                transactionType,
                transactionMode,
                payeeVpa,
                payerVpa,
                customerName,
                customerId,
                platform,
                merchantName,
                entityId,
                orderId
            } = transactionData;

            const { latestDueDate } = data

            return {
                txnRefNumber: isPresentOrDefault(transactionId, '-'),
                dateTime: isPresentOrDefault(dateTime, '-'),
                amount: isPresentOrDefault(amount, '-'),
                transactionType: isPresentOrDefault(transactionType, '-'),
                transactionMode: isPresentOrDefault(transactionMode, '-'),
                payeeVpa: isPresentOrDefault(payeeVpa, '-'),
                payerVpa: isPresentOrDefault(payerVpa, '-'),
                customerName: isPresentOrDefault(customerName, '-'),
                customerId: isPresentOrDefault(customerId, '-'),
                platform: isPresentOrDefault(platform, '-'),
                merchantName: isPresentOrDefault(merchantName, '-'),
                merchantId: isPresentOrDefault(entityId, '-'),
                orderId: isPresentOrDefault(orderId, '-'),
                latestDueDate: isPresentOrDefault(latestDueDate, '-'),
            };
        },
        createDisputeDetailData(details) {
            const {
                initiationMode,
                type,
                subType,
                orgTxnId,
                reqRefId,
                rrn,
                orgTxnDate,
                reqAdjFlag,
                reqAdjCode,
                reqAdjAmount,
                orgSettRespCode,
                crn,
                txnId,
                userRemarks,
                npciRemarks,
                reason,
                complaintStatus,
                metadata,
                payerVpa,
                payeeVpa,
                createdDate,
                modifiedDate,
                status
            } = details;
            return {
                initiationMode: isPresentOrDefault(initiationMode, '-'),
                type: isPresentOrDefault(type, '-'),
                subType: isPresentOrDefault(subType, '-'),
                orgTxnId: isPresentOrDefault(orgTxnId, '-'),
                reqRefId: isPresentOrDefault(reqRefId, '-'),
                rrn: isPresentOrDefault(rrn, '-'),
                orgTxnDate: isPresentOrDefault(orgTxnDate, '-'),
                reqAdjFlag: isPresentOrDefault(reqAdjFlag, '-'),
                reqAdjCode: isPresentOrDefault(reqAdjCode, '-'),
                reqAdjAmount: isPresentOrDefault(reqAdjAmount, 0.00),
                orgSettRespCode: isPresentOrDefault(orgSettRespCode, '-'),
                crn: isPresentOrDefault(crn, '-'),
                txnId: isPresentOrDefault(txnId, '-'),
                userRemarks: isPresentOrDefault(userRemarks, '-'),
                npciRemarks: isPresentOrDefault(npciRemarks, '-'),
                reason: isPresentOrDefault(reason, '-'),
                complaintStatus: isPresentOrDefault(complaintStatus, '-'),
                metadata: isPresentOrDefault(metadata, '-'),
                payerVpa: isPresentOrDefault(payerVpa, '-'),
                payeeVpa: isPresentOrDefault(payeeVpa, '-'),
                createdDate: isPresentOrDefault(createdDate, 0.00),
                modifiedDate: isPresentOrDefault(modifiedDate, 0.00),
                daysSinceCreated: moment().diff(
                    moment(createdDate, 'YYYY-MM-DD HH:mm:ss'),
                    'days'
                ),
                daysSinceModified: moment().diff(
                    moment(modifiedDate, 'YYYY-MM-DD HH:mm:ss'),
                    'days'
                ),
                status: isPresentOrDefault(status, '-'),
                
            };
        },
    }
);

export default ChargebackDetailFormat;
